<template>
  <div>
    <el-form ref="messageForm" :model="messageForm" :rules="messageFormRules" style="padding-right: 10px">
      <el-form-item label="步骤名称:" :label-width="addLabelWidth">
        <el-input class="stockInputs" disabled type="text" v-model="messageForm.name" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="选择模板:" prop="template_id" :label-width="addLabelWidth" class="stockInputs">
        <el-select @change="update" filterable v-model="messageForm.template_id" placeholder="请选择短信模板" class="">
          <el-option
            v-for="item in messages"
            :key="item.id"
            :label="item.sms_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getMessageListForNode } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      messageFormRules: {
        template_id: [
          { required: true, message: '短信模板不能为空', trigger: 'change' }
        ]
      },
      addLabelWidth: '90px',
      messageForm: this.contents,
      messages: [],
      search: {
        status: 2
      },
      page: 1
    }
  },
  computed: {
  },
  watch: {
    contents: function (val) {
      this.messageForm = val
    }
  },
  methods: {
    // 传值到父组件
    update() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'smsNode'
      choose.name = '短信'
      choose.template_id = this.messageForm.template_id
      choose.id = this.messageForm.id
      this.$emit('change', choose)
    },
    // 加载短信模板列表
    load() {
      getMessageListForNode(this.page, this.search).then((res) => {
        if (res.data.code === 0) {
          this.messages = res.data.data.list
        }
      })
    }
  },
  created() {
    this.load()
    console.log('contents', this.messageForm)
    // this.messageForm.messageId = this.recordDialog.content.template_id
  }
}
</script>

<style scoped>
</style>
